/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-15 11:39:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-05 09:47:03
 */
import React, { ReactElement, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { TabBar, TabPane } from "../../compnents/widgets/TabBar";
import { CompletedTreatment } from "./completedTreatment/completedTreatment";
import { PeddingMedicalTreatment } from "./peddingMedicalTreatment/peddingMedicalTreatment";
import { TreatmentsAdministered } from "./treatmentsAdministered/treatmentsAdministered";
import { Checkbox, Popover, Tabs } from "antd";
import { QuestionCircleTwoTone } from "@ant-design/icons";
import styles from './medicalSation.module.css'

export const MedicalSation = (props: {
  patientId?: string
  HZGLCKSJHQXData?: any
}): ReactElement => {
  const location: any = useLocation();

  const [selectTabKey, setSelectTabKey] = useState("0");
  const [showRefund, setShowRefund] = useState(true);

  const UseTabs = props.patientId ? Tabs : TabBar
  const UseTabPane = props.patientId ? Tabs.TabPane : TabPane

  return (
    <UseTabs
      className={props.patientId ? styles.containerP : styles.container}
      style={{ height: '100%', margin: props.patientId ? "0 " : "10px 0" }}
      defaultActiveKey={location.state ? location.state.selectKey : "0"}
      onChange={(e) => {
        setSelectTabKey(e)
      }}
      tabBarExtraContent={{
        right: (
          <span style={{ marginRight: 16, display: 'flex', alignItems: 'center', gap: 4 }}>
            <Checkbox
              checked={showRefund}
              onChange={(e) => setShowRefund(e.target.checked)}
            >
              包含退费数据
            </Checkbox>
            <Popover
              content={
                <div>
                  <p>
                    已退费数据无需执行，放在已执行处方里，如不要展示退费数据取消勾选
                  </p>
                </div>
              }
              placement='bottom'
              title='说明'
            >
              <QuestionCircleTwoTone />
            </Popover>
          </span>
        ),
      }}
    >
      <UseTabPane key="0" tab="待完成诊疗">
        <PeddingMedicalTreatment patientId={props.patientId} selectTabKey={selectTabKey} showRefund={showRefund} />
      </UseTabPane>
      <UseTabPane key="1" tab="已完成诊疗">
        <TreatmentsAdministered patientId={props.patientId} selectTabKey={selectTabKey} showRefund={showRefund} />
      </UseTabPane>
    </UseTabs>
  );
};
